const NavigationItemDefaultProps = {
  rootRoute: ''
}

export default NavigationItemDefaultProps
